import { AllasStandaloneNewsletterSignup } from '@/allas/components/NewsletterSignup';
import { LabradorComponent } from '@/types/component';

export const AllasLabradorNewsletterSignup: LabradorComponent = ({ type, data, meta }) => {
  return (
    <AllasStandaloneNewsletterSignup
      headline={data.headline}
      description={data.infoText}
      footer={data.integrityText}
      successModal={{
        content: data.successText,
      }}
      submitButton={{
        content: data.submitLabel || 'Ja tack!',
      }}
    />
  );
};
